// extracted by mini-css-extract-plugin
export default {"cartLink":"CartLink_cartLink__YC3sl","cartIcon":"CartLink_cartIcon__-ie1D","cartCounter":"CartLink_cartCounter__Y0W+n"};